import { Div, DivProps, Button } from '@kizi/core-components';
import React, { useState } from 'react';
import styled from '@emotion/styled';

const Body = styled(Div)<{ lines: number; fontSize; lineHeight }>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 1.5;
  overflow: hidden;

  &.open {
    height: auto;
  }

  &.closed {
    height: calc(
      (${({ fontSize, lines, lineHeight }) => fontSize * lines * lineHeight})
    );
    -webkit-line-clamp: ${(props) => props.lines};
    text-overflow: ellipsis;
  }
`;
export interface TruncatedTextProps extends DivProps {
  lines: number;
  showLess?: string;
  showMore?: string;
  hasShowMoreButton: boolean;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({
  children,
  fontSize = 16,
  lineHeight = 1.6,
  lines,
  showLess = 'Verberg',
  showMore = 'Lees meer',
  hasShowMoreButton,
  ...divProps
}) => {
  const [className, setClassName] = React.useState('closed');

  const [isOpen, setIsOpen] = useState(false);
  const textButton = isOpen ? showLess : showMore;

  return (
    <>
      <Body
        className={className}
        fontSize={fontSize}
        lines={lines}
        lineHeight={lineHeight}
        {...divProps}
      >
        {children}
      </Body>
      {hasShowMoreButton && (
        <Button
          mt={1}
          onClick={(e) => {
            e.stopPropagation();
            const nextIsOpen = !isOpen;
            setIsOpen(nextIsOpen);
            setClassName(nextIsOpen ? 'open' : 'closed');
          }}
          variant="transparentSmall"
          width="fit-content"
        >
          {textButton}
        </Button>
      )}
    </>
  );
};
